import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipComponent } from './tooltip.component';
import { MobileTooltipModule } from '@finder/shared/components/mobile-tooltip/mobile-tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        MobileTooltipModule,
    ],
    declarations: [
        TooltipComponent,
    ],
    providers: [],
    exports: [
        TooltipComponent,
    ]
})
export class TooltipModule {}
